import { loadDocentes } from "../helpers/docentes"


const initialState = {
    docentes: []
}

const DOCENTES_LOADED = '[DOCENTES LD] DOCENTES LOADED'
const DOCENTES_LOGOUT = '[DOCENTES LD] DOCENTES LOGOUT'

export const startLoadingdocentes = () => {
    return async (dispatch) => {
        const docentes = await loadDocentes();
        dispatch(setDocentes(docentes))
    }
}

export const setDocentes = (docentes) => ({
    type: DOCENTES_LOADED,
    payload: docentes
})


export const docenteLogout = () => ({
    type: DOCENTES_LOGOUT,
})

const DocentesReducer = (state = initialState, action ) => {
    switch (action.type) {
        case DOCENTES_LOADED:
            return {
                ...state,
                docentes: [...action.payload]
            }
        case DOCENTES_LOGOUT:
            return state = initialState
        default:
            return state
    }
}

export default DocentesReducer;